module.exports = __webpack_public_path__ + "static/media/ritratto.22f64eb1.jpg";